import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Slider from "@mui/material/Slider";

const followersMarks = [
  {
    value: 100,
    scaledValue: 0.25,
    label: "0.25"
  },
  {
    value: 200,
    scaledValue: 0.5,
    label: "0.5"
  },
  {
    value: 300,
    scaledValue: 1,
    label: "1"
  },
  {
    value: 400,
    scaledValue: 5,
    label: "5"
  },
  {
    value: 500,
    scaledValue: 10,
    label: "10"
  },
  {
    value: 600,
    scaledValue: 50,
    label: ">50"
  },
  
 
]

class Sliderbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //  value: this.props.value_area,
    };
    console.log("kkkkkkkkkkkkkkkkkkkkkkkkkk",this.props.collapsed,this.props.collapsed2)
  }


//setState{

//}
  //this.props.scaleValues_area(this.props.value_area)

 

  render() {
    return (
      <div style={{ padding_top: "10px", padding_left: "50px", textAlign: "center" }}>
        
        {(this.props.collapsed ) ||((this.props.collapsed2) && (this.props.glofriskassesmentselected=='cgl' ))  ?  ( // Add this conditional check
          <Slider
            style={{ maxWidth: 200 }}
            value={this.props.value_area}
            min={this.props.min_ar}
            step={100}
            max={this.props.max_ar}
            marks={followersMarks}
            scale={this.props.scaleValues_area}
            onChange={this.props.handleChange_area}
            valueLabelDisplay="auto"
            aria-labelledby="non-linear-slider"
          />
        ) : (
          <Slider // Disabled slider
            style={{ maxWidth: 200 }}
            value={this.props.value_area}
            disabled
            valueLabelDisplay="auto"
            aria-labelledby="non-linear-slider"
          />
    
      
    )}
    </div>
        
         ) 
}
}
export default Sliderbar;